module.exports = __webpack_public_path__ + "static/Poteha-Regular-2f75d576a284ee79fe156b78e789f250.otf";